$(function () {
  const slickBaseSwiper = $(".swiper-base .swiper-base__slick");

  //@ts-ignore
  slickBaseSwiper.slick({
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    infinite: true,
    dots: true,
    dotsClass: "swiper-base-dots",
  });

  $(".swiper-base-prev").click(function () {
    //@ts-ignore
    slickBaseSwiper.slick("slickPrev");
  });

  $(".swiper-base-next").click(function () {
    //@ts-ignore
    slickBaseSwiper.slick("slickNext");
  });
});
